import { render } from "./SelectCollection.vue.js?vue&type=template&id=1940bcef&scoped=true!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./SelectCollection.vue?vue&type=template&id=1940bcef&scoped=true"
import script from "./SelectCollection.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./SelectCollection.vue?vue&type=script&lang=js"
export * from "./SelectCollection.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./SelectCollection.vue?vue&type=script&lang=js"

import "./SelectCollection.vue.scss?vue&type=style&index=0&id=1940bcef&scoped=true&lang=scss!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./SelectCollection.vue?vue&type=style&index=0&id=1940bcef&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1940bcef"],['__file',"src/SharedWeb/scripts/dynamic-component-editor/components/SelectCollection.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1940bcef"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1940bcef', __exports__)) {
    api.reload('1940bcef', __exports__)
  }
  
  module.hot.accept("./SelectCollection.vue.js?vue&type=template&id=1940bcef&scoped=true!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./SelectCollection.vue?vue&type=template&id=1940bcef&scoped=true", () => {
    api.rerender('1940bcef', render)
  })

}


export default __exports__